import { render, staticRenderFns } from "./QueuedCompanyMoveDbs.vue?vue&type=template&id=c6864888&scoped=true&"
import script from "./QueuedCompanyMoveDbs.vue?vue&type=script&lang=ts&"
export * from "./QueuedCompanyMoveDbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6864888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6864888')) {
      api.createRecord('c6864888', component.options)
    } else {
      api.reload('c6864888', component.options)
    }
    module.hot.accept("./QueuedCompanyMoveDbs.vue?vue&type=template&id=c6864888&scoped=true&", function () {
      api.rerender('c6864888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/QueuedCompanyMoveDbs.vue"
export default component.exports